import { memo, useState } from 'react'
import { Icon } from '@winnin/winnin_ui.components.icon'

import { RCTooltip } from 'components/RCTooltip'
import { useTranslate } from 'lib/tolgee'
import './index.scss'

const TOLGEE_PREFIX = 'GridListSwitcher'

const GridIcon = memo(({ onClick, active }) => {
  const t = useTranslate()

  return (
    <RCTooltip
      direction="top"
      tooltipMessage={t({
        key: `${TOLGEE_PREFIX}-cardLabel`,
        defaultValue: 'Card visualization',
      })}
    >
      <button className={active === 'grid' ? 'active' : null} onClick={onClick}>
        <Icon icon={active === 'grid' ? 'gridFilled' : 'gridOutline'} />
      </button>
    </RCTooltip>
  )
})

const ListIcon = memo(({ onClick, active }) => {
  const t = useTranslate()

  return (
    <RCTooltip
      direction="top"
      tooltipMessage={t({
        key: `${TOLGEE_PREFIX}-tableLabel`,
        defaultValue: 'Table visualization',
      })}
    >
      <button className={active === 'list' ? 'active' : null} onClick={onClick}>
        <Icon icon={active === 'list' ? 'list' : 'listOutline'} />
      </button>
    </RCTooltip>
  )
})

const GridListSwitcher = memo(({ active, onSetGrid, onSetList, iconsOrder, isCreator }) => {
  const [activeViewMode, setActiveViewMode] = useState(active)

  const handleSetGrid = () => {
    setActiveViewMode('grid')
    onSetGrid?.()
  }

  const handleSetList = () => {
    setActiveViewMode('list')
    onSetList?.()
  }

  const gridIcon = <GridIcon key="grid" onClick={handleSetGrid} active={activeViewMode} />
  const listIcon = <ListIcon key="list" onClick={handleSetList} active={activeViewMode} />

  if (isCreator) {
    return null
  }

  return <div className="GridListSwitcher">{iconsOrder === 'list' ? [listIcon, gridIcon] : [gridIcon, listIcon]}</div>
})

export default GridListSwitcher
